<template>
    <v-tab-item :value="tab">
        <div class="human-resource-item--wrap">
            <div class="mb-12 mb-lg-20">
                <v-row align="center">
                    <v-col cols="auto"> <h5 class="page-text--lg">{{ title }}</h5> </v-col> <v-spacer />
                    <v-col cols="auto"> <human-resource-search withoutKeys /> </v-col>
                </v-row>
            </div>
            <template v-if="applications.length">
                <div>
                    <human-resource-item v-for="item in applications" :key="item?._id" :value="item" :recruitment="item.recruitment" />
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="grey-f7 rounded-lg pa-20 pa-md-30">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        공고 지원자가 없습니다.
                    </p>
                    <v-btn to="/dashboard/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 관리하기</span>
                    </v-btn>
                </v-layout>
            </template>
        </div>

        <!-- <v-layout column fill-height>
            <v-card-title class="page-text--lg line-height-1"> {{ title }} </v-card-title>
            <v-card-text style="flex: 1 1 auto; overflow-y: auto">
                <template v-if="applications.length">
                    <human-resource-item v-for="item in applications" :key="item?._id" :value="item" :recruitment="item.recruitment" class="my-10" />
                    <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-16" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                </template>
                <template v-else>
                    <v-layout column justify-center align-center fill-height class="text-center text-h4 font-weight-bold" style="line-height: 1.4">
                        안녕하세요, 담당자님. <br />
                        공고 지원자가 없습니다.
                        <v-btn x-large color="primary" class="my-24" to="/dashboard/recruitments"> 채용공고 관리하기 </v-btn>
                    </v-layout>
                </template>
            </v-card-text>
        </v-layout> -->
    </v-tab-item>
</template>

<script>
import api from "@/api";

import HumanResourceItem from "./human-resource-item.vue";
import HumanResourceSearch from "./human-resource-search.vue";

export default {
    components: {
        HumanResourceItem,
        HumanResourceSearch,
    },
    props: {
        tab: { type: String },
        title: { type: String },
    },
    data: () => ({
        applications: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        shows() {
            return this.$route.params?.tab == this.tab;
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        sort() {
            return this.$route.query.sort || JSON.stringify({ appliedAt: -1 });
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;
            delete query["sort"];

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
        page() {
            if (this.shows) this.search();
        },
        params() {
            if (this.shows) this.search();
        },
    },
    methods: {
        init() {
            const { ...query } = this.$route.query;
            if (query.page) delete query.page;
            if (query.page != this.$route.query.page) {
                this.$router.replace({ query });
            }
            this.$nextTick(this.search);
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, sort, params } = this;
                const { summary, applications } = await api.v1.company.humanResource.getQualifiers({
                    headers: { skip, limit, sort },
                    params,
                });
                this.summary = summary;
                this.applications = applications;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
